import React from "react"
import Avatar from '@mui/material/Avatar'
import imagePaths from "../../configuration/imagePaths"

export default function AvatarImage(props) {
    const {width} = props

    return (<>
        <Avatar 
            alt="Ignacio Rivano" 
            src={imagePaths.selfie}
            sx={{ width: width -100, height: width - 100}}
        />
    </>)
}